(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('quickSidebarUsers', ['UserSearchService', 'HelperService', '$compile', 'SharedAgendaBroadcast', '$translate', QuickSidebarUsersFn]);

    /* main quick sidebar directive for user-area */
    function QuickSidebarUsersFn(UserSearchService, HelperService, $compile, SharedAgendaBroadcast, $translate) {
        var directive = {
            restrict: 'A',
            templateUrl: '/app/ringfoon/templates/quick-sidebar-users.template.html',
            scope: true,
            link: link
        };
        return directive;

        var listener;

        function link(scope, element) {
            // user search result element
            var el = element.find(".media-list");
            // search value
            scope.searchValue = null;
            // number found
            scope.numberFound = 0;


            // activate
            activate();

            // activate
            function activate() {
                scope.errorMessage = "";
                // slim scroll
                el.slimScroll({ height: '90vh' }); // 90 % viewport height  (not 100 because of windows-task-row fe)

                listener = scope.$on(SharedAgendaBroadcast.AgendaChanged, function () {
                    scope.delete();
                });
            } // activate

            
            // search 
            scope.search = function () {
                // remove dom-elements (then the scopes will be destroyed)
                empty();

                // is there something to search for ?
                if (!scope.searchValue || scope.searchValue.length === 0) { return; }
                
                // clear possible errormessage and validate search input 
                scope.errorMessage = "";
                HelperService.enoughCharactersForFilterCheck(scope.searchValue);
                if (!HelperService.enoughCharactersForFilterCheck(scope.searchValue)) {
                    scope.errorMessage = $translate.instant('Search_Input_Validation_Error');
                    return;
                }
                
                // execute search
                UserSearchService.search(scope.searchValue).then(function (result) {
                    var users = HelperService.prepareUserSearchResult(result, true);
                    scope.numberFound = users.length;
                    var i = 0;
                    var len = users.length;
                    for (i; i < len; i++) {
                        var user = users[i];
                        // new child scope
                        var newScope = scope.$new(false);
                        newScope.user = user;
                        newScope.address = formatAddress(user);
                        // new dom 
                        var e = '<li class="media"><a class="quick-sidebar-search-result" quick-sidebar-user-search-item user="user" address="address"></a></li>';
                        el.append($compile(e)(newScope));
                    } // for
                });
            };

            // remove search value
            scope.delete = function () {
                // clear
                empty();
                // reset 
                scope.searchValue = null;
            };

            function formatAddress(user) {
                let address = user.street ? user.street : '';
                address += user.streetNumber ? (user.street ? ' ' + user.streetNumber : user.streetNumber) : '';
                address += (user.street || user.streetNumber) && (user.zipCode || user.location) ? ', ' : '';
                address += user.zipCode ? user.zipCode : '';
                address += user.location ? (user.location ? ' ' + user.location : user.location) : '';
                return address;                
            }

            // remove dom-elements (then the scopes will be destroyed)
            function empty() {
                scope.numberFound = 0;
                el.empty();
            }

            // destroy
            scope.$on("$destroy", function () {
                empty();
                
                if (listener) {
                    listener();
                    listener = null;
                }
            });

        }
    }

})();